module.exports = __webpack_public_path__ + "media/images/emblems/Burgdorf-coat_of_arms-ad8411eb9bec5b1e21d1b448d4bc8768.svg";